module.exports = __webpack_public_path__ + "static/media/hydrafacial.7a52b5bc.jpg";